import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
	DefaultValues,
	FormProvider,
	SubmitHandler,
	useForm,
} from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { FormType } from '@/api/enum/formType.enum';
import {
	Dispatch,
	forwardRef,
	SetStateAction,
	useEffect,
	useImperativeHandle,
} from 'react';
import AppTextField from '@/common/components/form-inputs/AppTextField';

interface Props {
	type: FormType;
	details?: any;
	setType: Dispatch<SetStateAction<FormType>>;
}

const EditHealthConditionForm = forwardRef(
	({ type, setType, details }: Props, ref) => {
		const { t } = useTranslation();
		const defaultValues: DefaultValues<any> = {};

		useEffect(() => {
			if (details) methods.reset(details);
		}, [details]);

		const formSchema = Yup.object().shape({});
		const methods = useForm<any>({
			defaultValues,
			resolver: yupResolver(formSchema),
			mode: 'onChange',
			shouldFocusError: true,
		});

		useImperativeHandle(ref, () => ({
			getFormData: () => methods.getValues(),
			validateForm: () => {
				methods.trigger();
				methods.formState.isValid;
				return methods.trigger().then(() => methods.formState.isValid);
			},
		}));

		return (
			<>
				<FormProvider {...methods}>
					<Typography variant='h6' sx={{ fontWeight: 'bold' }} marginBottom={2}>
						{t('preAdmission.mentalHealthCondition')}
					</Typography>
					<form onSubmit={methods.handleSubmit((e) => e.preventDefault())}>
						<Grid container spacing={3} marginTop={0} marginBottom={3}>
							<Grid size={12}>
								<AppTextField
									control={methods.control}
									multiline
									name='cognitiveProblem'
									label={t('preAdmission.cognitiveProblem')}
									rows={2}
								/>
							</Grid>
							<Grid size={12}>
								<AppTextField
									control={methods.control}
									multiline
									name='emotionalProblem'
									label={t('preAdmission.emotionalProblem')}
									rows={2}
								/>
							</Grid>
							<Grid size={12}>
								<AppTextField
									control={methods.control}
									multiline
									name='behavioralImpairments'
									label={t('preAdmission.behavioralImpairments')}
									rows={2}
								/>
							</Grid>
							<Grid size={12}>
								<AppTextField
									control={methods.control}
									multiline
									name='interpersonalImpairments'
									label={t('preAdmission.interpersonalImpairments')}
									rows={2}
								/>
							</Grid>
							<Grid size={12}>
								<AppTextField
									control={methods.control}
									multiline
									name='riskElements'
									label={t('preAdmission.riskElements')}
									rows={2}
								/>
							</Grid>
						</Grid>
					</form>
				</FormProvider>
			</>
		);
	}
);

EditHealthConditionForm.displayName = 'EditHealthConditionForm';

export default EditHealthConditionForm;
